import * as Intro from 'src/styles/views/intro'
import introImage from 'src/assets/images/intro/Group 4562.png'

export const Introduce = () => {
  return (
    <Intro.IntroduceWrap>
      <Intro.Title>
        금융사기를 예방하는 서비스
        <br />
        스마트피싱보호를 소개해 드릴게요.
      </Intro.Title>
      <Intro.SubTitle>
        신종 금융사기에 대한 빅데이터를 수집 및 분석하여 향후 발생할 수 있는 사기 수법과 사기를
        예측해 피싱을 예방하는 기능을 제공합니다.
      </Intro.SubTitle>
      <Intro.IntroduceImageWrap src={introImage}>
      </Intro.IntroduceImageWrap>
    </Intro.IntroduceWrap>
  )
}
